import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import ClipboardIcon from '@mui/icons-material/AssignmentSharp';
import ClipboardSuccessIcon from '@mui/icons-material/AssignmentTurnedInSharp';
import ClipboardErrorIcon from '@mui/icons-material/AssignmentLateSharp';

export default function CopyToClipboardButton({
  data,
  size = 'medium',
  subject,
}: {
  data: string;
  size?: 'small' | 'medium';
  subject?: string;
}) {
  // Reset status when `data` changes — the previously copied content is
  // stale, so the icon shouldn't keep showing SUCCESS/ERROR. Adjusting state
  // during render per the React docs' previous-prop pattern.
  const [prevData, setPrevData] = useState(data);
  const [status, setStatus] = useState<'INIT' | 'ERROR' | 'SUCCESS'>('INIT');
  if (prevData !== data) {
    setPrevData(data);
    setStatus('INIT');
  }

  function doCopy() {
    navigator.clipboard.writeText(data).then(
      () => setStatus('SUCCESS'),
      () => setStatus('ERROR'),
    );
  }

  const iconFontSize = size === 'small' ? 'small' : 'medium';
  const what = subject ? `${subject} ` : '';

  switch (status) {
    case 'INIT':
      return (
        <IconButton title={`Copy ${what}to clipboard`} onClick={doCopy} size={size}>
          <ClipboardIcon fontSize={iconFontSize} />
        </IconButton>
      );
    case 'ERROR':
      return (
        <IconButton title={`Could not copy ${what}to clipboard`} onClick={doCopy} size={size}>
          <ClipboardErrorIcon fontSize={iconFontSize} />
        </IconButton>
      );
    case 'SUCCESS':
      return (
        <IconButton title={`Copied ${what}to clipboard`} onClick={doCopy} size={size}>
          <ClipboardSuccessIcon fontSize={iconFontSize} />
        </IconButton>
      );
  }
}
